import { AdvancedSettingsConstants } from '../../utils/constants/AdvancedSettingsConstants';

const AdvancedSettings = () => {
    return (
        <div className="pens-container" style={{ minHeight: '10rem' }}>
            <h5 className="my-3">
                {AdvancedSettingsConstants.manageAdvancedSettings}
            </h5>
            <div className="d-flex justify-content-unset align-items-center gap-2 manage-advanced-settings">
                <p className="text-secondary mb-0 me-1">
                    {AdvancedSettingsConstants.enableNegNemInCommodities}
                </p>
                <label className="switch mt-0">
                    <input type="checkbox" checked={true} />
                    <span className="slider round" />
                </label>
            </div>
        </div>
    );
};

export default AdvancedSettings;
